import { Routes } from '@angular/router';
import { anonymousGuard } from './guards/anonymous.guard';
import {
  ActivityRoute,
  DataSpaceRoute,
  IntegrationsRouting,
  KPIRouting,
  SystemConfigurationRoute,
  userRoute,
} from './shared/routes/custom.routes';

import { authGuard } from './guards/auth.guard';
import { OfflineGuard } from './guards/offline.guard';
import { ContentLayout } from './shared/layout-components/content-layout/content-layout';
import { ContentLayoutComponent } from './shared/layout-components/layout/content-layout/content-layout.component';
import { NotFound } from './shared/layout-components/not-found/not-found';
export const routes: Routes = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () =>
      import('./authentication/authentication-routing.module').then((m) => m.AuthRoutes),
    canActivate: [anonymousGuard],
  },
  {
    path: '',
    component: ContentLayoutComponent,
    canActivate: [authGuard, OfflineGuard],
    children: [
      userRoute,
      SystemConfigurationRoute,
      ActivityRoute,
      IntegrationsRouting,
      DataSpaceRoute,
      KPIRouting,
    ],
  },
  {
    path: 'agent',
    canActivate: [authGuard],
    component: ContentLayout,
    loadChildren: () =>
      import('../../src/app/components/agent/chat/chat.routes').then((m) => m.ChatRoutes),
  },
  {
    path: 'agent/welcome',
    canActivate: [authGuard],
    loadComponent: () =>
      import('../../src/app/components/agent/welcome/welcome').then((m) => m.Welcome),
  },
  {
    path: 'callback',
    loadComponent: () =>
      import('../../src/app/components/data-space/google-callback/google-callback.component').then(
        (m) => m.GoogleCallbackComponent
      ),
  },
  {
    path: '**',
    children: [
      {
        path: '',
        component: NotFound,
      },
    ],
  },
];
